import type { EmployerType, PaginatedResponse } from "types/DataTypes";

import { api } from "./api.ts";

export type GetEmployersArgs = {
  searchTerm?: string;
  limit?: number;
  offset?: number;
};

export const employerAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getEmployers: build.query<
      PaginatedResponse<EmployerType>,
      GetEmployersArgs
    >({
      query: ({ searchTerm, limit = 25, offset = 0 }) => ({
        url: `api/v1/employers/`,
        method: "GET",
        params: {
          ...(searchTerm ? { filter: searchTerm } : {}),
          limit,
          offset,
        },
      }),
      providesTags: ["Employers"],
    }),
    getEmployerById: build.query<EmployerType, { id: string }>({
      query: ({ id }) => ({
        url: `api/v1/employers/${id}/`,
        method: "GET",
      }),
    }),
    patchEmployerById: build.mutation({
      query: ({ id, data }) => ({
        url: `api/v1/employers/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),
    createEmployer: build.mutation({
      query: ({ data }) => ({
        url: `api/v1/employers/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Employers"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetEmployersQuery,
  useGetEmployerByIdQuery,
  usePatchEmployerByIdMutation,
  useCreateEmployerMutation,
} = employerAPI;
